import { render, staticRenderFns } from "./NewAppEnqB2b.vue?vue&type=template&id=4dccfccc&"
import script from "./NewAppEnqB2b.vue?vue&type=script&lang=js&"
export * from "./NewAppEnqB2b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports